/* tslint:disable */
/* eslint-disable */
/**
 * gateway-datavote API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface BVResultsComboMongo
 */
export interface BVResultsComboMongo {
    /**
     * 
     * @type {string}
     * @memberof BVResultsComboMongo
     */
    'codeCommune'?: string;
    /**
     * 
     * @type {string}
     * @memberof BVResultsComboMongo
     */
    'commune'?: string;
    /**
     * 
     * @type {string}
     * @memberof BVResultsComboMongo
     */
    'departement'?: string;
    /**
     * 
     * @type {{ [key: string]: BvResults; }}
     * @memberof BVResultsComboMongo
     */
    'bvResultsMap'?: { [key: string]: BvResults; };
}
/**
 * 
 * @export
 * @interface Ban
 */
export interface Ban {
    /**
     * 
     * @type {string}
     * @memberof Ban
     */
    'codeBan'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ban
     */
    'libelleBan'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ban
     */
    'latitude'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ban
     */
    'longitude'?: string;
}
/**
 * 
 * @export
 * @interface BureauDeVote
 */
export interface BureauDeVote {
    /**
     * 
     * @type {string}
     * @memberof BureauDeVote
     */
    'id_brut_reu'?: string;
    /**
     * 
     * @type {string}
     * @memberof BureauDeVote
     */
    'id_brut_insee'?: string;
    /**
     * 
     * @type {string}
     * @memberof BureauDeVote
     */
    'code_commune'?: string;
    /**
     * 
     * @type {string}
     * @memberof BureauDeVote
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof BureauDeVote
     */
    'libelle_reu'?: string;
    /**
     * 
     * @type {string}
     * @memberof BureauDeVote
     */
    'num_voie_reu'?: string;
    /**
     * 
     * @type {string}
     * @memberof BureauDeVote
     */
    'voie_reu'?: string;
    /**
     * 
     * @type {string}
     * @memberof BureauDeVote
     */
    'cp_reu'?: string;
    /**
     * 
     * @type {string}
     * @memberof BureauDeVote
     */
    'commune_reu'?: string;
    /**
     * 
     * @type {string}
     * @memberof BureauDeVote
     */
    'nb_adresses_initial'?: string;
    /**
     * 
     * @type {string}
     * @memberof BureauDeVote
     */
    'nb_adresses_final'?: string;
    /**
     * 
     * @type {string}
     * @memberof BureauDeVote
     */
    'id_brut_miom'?: string;
    /**
     * 
     * @type {{ [key: string]: Array<ResultatsVote>; }}
     * @memberof BureauDeVote
     */
    'resultats'?: { [key: string]: Array<ResultatsVote>; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof BureauDeVote
     */
    'nbInsrits'?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof BureauDeVote
     */
    'nbAbstentions'?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface BvData
 */
export interface BvData {
    /**
     * 
     * @type {Array<BvGeoMongo>}
     * @memberof BvData
     */
    'bvGeoMongo'?: Array<BvGeoMongo>;
    /**
     * 
     * @type {Array<BvInfoMongo>}
     * @memberof BvData
     */
    'bvInfoMongo'?: Array<BvInfoMongo>;
    /**
     * 
     * @type {Array<BVResultsComboMongo>}
     * @memberof BvData
     */
    'bvResultsComboMongo'?: Array<BVResultsComboMongo>;
    /**
     * 
     * @type {Array<BvToIrisMongo>}
     * @memberof BvData
     */
    'bvToIrisMongo'?: Array<BvToIrisMongo>;
    /**
     * 
     * @type {EpciElem}
     * @memberof BvData
     */
    'epciData'?: EpciElem;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: { [key: string]: string; }; }; }}
     * @memberof BvData
     */
    'inseeData'?: { [key: string]: { [key: string]: { [key: string]: string; }; }; };
    /**
     * 
     * @type {{ [key: string]: IrisShape; }}
     * @memberof BvData
     */
    'shapeIris'?: { [key: string]: IrisShape; };
    /**
     * 
     * @type {GeoJsonDataDTO}
     * @memberof BvData
     */
    'shapeOfEpci'?: GeoJsonDataDTO;
    /**
     * 
     * @type {{ [key: string]: Array<BVResultsComboMongo>; }}
     * @memberof BvData
     */
    'bvResultsEpci'?: { [key: string]: Array<BVResultsComboMongo>; };
    /**
     * 
     * @type {Array<IrisToBanMongo>}
     * @memberof BvData
     */
    'irisToBanMongo'?: Array<IrisToBanMongo>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BvData
     */
    'convertionTableForBvs'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface BvGeoMongo
 */
export interface BvGeoMongo {
    /**
     * 
     * @type {string}
     * @memberof BvGeoMongo
     */
    'codeCommune'?: string;
    /**
     * 
     * @type {Array<GeoBureauxDeVote>}
     * @memberof BvGeoMongo
     */
    'bureauxDeVote'?: Array<GeoBureauxDeVote>;
}
/**
 * 
 * @export
 * @interface BvInfoMongo
 */
export interface BvInfoMongo {
    /**
     * 
     * @type {string}
     * @memberof BvInfoMongo
     */
    'codeCommune'?: string;
    /**
     * 
     * @type {Array<BureauDeVote>}
     * @memberof BvInfoMongo
     */
    'bureauxDeVote'?: Array<BureauDeVote>;
}
/**
 * 
 * @export
 * @interface BvResults
 */
export interface BvResults {
    /**
     * 
     * @type {string}
     * @memberof BvResults
     */
    'codeBV'?: string;
    /**
     * 
     * @type {string}
     * @memberof BvResults
     */
    'idBrutMiom'?: string;
    /**
     * 
     * @type {{ [key: string]: Election; }}
     * @memberof BvResults
     */
    'elections'?: { [key: string]: Election; };
}
/**
 * 
 * @export
 * @interface BvToIrisMongo
 */
export interface BvToIrisMongo {
    /**
     * 
     * @type {string}
     * @memberof BvToIrisMongo
     */
    'codeBv'?: string;
    /**
     * 
     * @type {string}
     * @memberof BvToIrisMongo
     */
    'codeCommune'?: string;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof BvToIrisMongo
     */
    'iris'?: { [key: string]: Array<string>; };
}
/**
 * 
 * @export
 * @interface Candidat
 */
export interface Candidat {
    /**
     * 
     * @type {number}
     * @memberof Candidat
     */
    'r'?: number;
    /**
     * 
     * @type {string}
     * @memberof Candidat
     */
    'np'?: string;
    /**
     * 
     * @type {string}
     * @memberof Candidat
     */
    'nomPrenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof Candidat
     */
    'sexe'?: string;
    /**
     * 
     * @type {string}
     * @memberof Candidat
     */
    'nuance'?: string;
    /**
     * 
     * @type {string}
     * @memberof Candidat
     */
    'binome'?: string;
    /**
     * 
     * @type {string}
     * @memberof Candidat
     */
    'liste'?: string;
}
/**
 * 
 * @export
 * @interface City
 */
export interface City {
    /**
     * 
     * @type {string}
     * @memberof City
     */
    'codeInsee'?: string;
    /**
     * 
     * @type {string}
     * @memberof City
     */
    'libele'?: string;
}
/**
 * 
 * @export
 * @interface Election
 */
export interface Election {
    /**
     * 
     * @type {string}
     * @memberof Election
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Election
     */
    'annee'?: string;
    /**
     * 
     * @type {string}
     * @memberof Election
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof Election
     */
    'tour'?: string;
    /**
     * 
     * @type {number}
     * @memberof Election
     */
    'ins'?: number;
    /**
     * 
     * @type {number}
     * @memberof Election
     */
    'abs'?: number;
    /**
     * 
     * @type {number}
     * @memberof Election
     */
    'vot'?: number;
    /**
     * 
     * @type {number}
     * @memberof Election
     */
    'bla'?: number;
    /**
     * 
     * @type {number}
     * @memberof Election
     */
    'nuls'?: number;
    /**
     * 
     * @type {number}
     * @memberof Election
     */
    'exp'?: number;
    /**
     * 
     * @type {string}
     * @memberof Election
     */
    'cir'?: string;
    /**
     * 
     * @type {string}
     * @memberof Election
     */
    'cc'?: string;
    /**
     * 
     * @type {Array<Candidat>}
     * @memberof Election
     */
    'c'?: Array<Candidat>;
}
/**
 * 
 * @export
 * @interface EpciElem
 */
export interface EpciElem {
    /**
     * 
     * @type {string}
     * @memberof EpciElem
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof EpciElem
     */
    'libele'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EpciElem
     */
    'isEpci'?: boolean;
    /**
     * 
     * @type {Array<City>}
     * @memberof EpciElem
     */
    'codeInsee'?: Array<City>;
}
/**
 * 
 * @export
 * @interface Feature
 */
export interface Feature {
    /**
     * 
     * @type {string}
     * @memberof Feature
     */
    'type'?: string;
    /**
     * 
     * @type {Geometry}
     * @memberof Feature
     */
    'geometry'?: Geometry;
    /**
     * 
     * @type {Properties}
     * @memberof Feature
     */
    'properties'?: Properties;
}
/**
 * 
 * @export
 * @interface GeoBureauxDeVote
 */
export interface GeoBureauxDeVote {
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'commune_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'libelle_voie'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'num_voie'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'voie'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'complement1'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'complement2'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'lieu_dit'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'code_postal'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'commune'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'canton_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'circonscription_code'?: string;
    /**
     * 
     * @type {number}
     * @memberof GeoBureauxDeVote
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoBureauxDeVote
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoBureauxDeVote
     */
    'geo_score'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'geo_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'geo_adresse'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'geo_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'geo_ligne'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'geo_l4'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoBureauxDeVote
     */
    'geo_l5'?: string;
}
/**
 * 
 * @export
 * @interface GeoJson
 */
export interface GeoJson {
    /**
     * 
     * @type {string}
     * @memberof GeoJson
     */
    'type'?: string;
    /**
     * 
     * @type {Array<Feature>}
     * @memberof GeoJson
     */
    'features'?: Array<Feature>;
}
/**
 * 
 * @export
 * @interface GeoJsonDataDTO
 */
export interface GeoJsonDataDTO {
    /**
     * 
     * @type {GeoJson}
     * @memberof GeoJsonDataDTO
     */
    'cityGeoJson'?: GeoJson;
    /**
     * 
     * @type {GeoJson}
     * @memberof GeoJsonDataDTO
     */
    'epciGeoJson'?: GeoJson;
    /**
     * 
     * @type {Array<any>}
     * @memberof GeoJsonDataDTO
     */
    'centroid'?: Array<any>;
}
/**
 * 
 * @export
 * @interface Geometry
 */
export interface Geometry {
    /**
     * 
     * @type {string}
     * @memberof Geometry
     */
    'type'?: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof Geometry
     */
    'coordinates'?: Array<any>;
}
/**
 * 
 * @export
 * @interface IrisShape
 */
export interface IrisShape {
    /**
     * 
     * @type {string}
     * @memberof IrisShape
     */
    'irisCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof IrisShape
     */
    'irisName'?: string;
    /**
     * 
     * @type {string}
     * @memberof IrisShape
     */
    'geom'?: string;
}
/**
 * 
 * @export
 * @interface IrisToBanMongo
 */
export interface IrisToBanMongo {
    /**
     * 
     * @type {string}
     * @memberof IrisToBanMongo
     */
    'iris'?: string;
    /**
     * 
     * @type {string}
     * @memberof IrisToBanMongo
     */
    'codeCommune'?: string;
    /**
     * 
     * @type {{ [key: string]: Array<Ban>; }}
     * @memberof IrisToBanMongo
     */
    'banMap'?: { [key: string]: Array<Ban>; };
}
/**
 * 
 * @export
 * @interface Properties
 */
export interface Properties {
    /**
     * 
     * @type {string}
     * @memberof Properties
     */
    'codgeo'?: string;
    /**
     * 
     * @type {string}
     * @memberof Properties
     */
    'insee'?: string;
    /**
     * 
     * @type {string}
     * @memberof Properties
     */
    'c_arinsee'?: string;
    /**
     * 
     * @type {string}
     * @memberof Properties
     */
    'insee_com'?: string;
    /**
     * 
     * @type {string}
     * @memberof Properties
     */
    'dep'?: string;
    /**
     * 
     * @type {string}
     * @memberof Properties
     */
    'reg'?: string;
    /**
     * 
     * @type {string}
     * @memberof Properties
     */
    'xcl2154'?: string;
    /**
     * 
     * @type {string}
     * @memberof Properties
     */
    'ycl2154'?: string;
    /**
     * 
     * @type {string}
     * @memberof Properties
     */
    'libgeo'?: string;
}
/**
 * 
 * @export
 * @interface ResultatsVote
 */
export interface ResultatsVote {
    /**
     * 
     * @type {number}
     * @memberof ResultatsVote
     */
    'nbVoix'?: number;
    /**
     * 
     * @type {Candidat}
     * @memberof ResultatsVote
     */
    'candidat'?: Candidat;
}

/**
 * BVCtrlApi - axios parameter creator
 * @export
 */
export const BVCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Data
         * @param {string} [codeInsee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteAllGet: async (codeInsee?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vote/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codeInsee !== undefined) {
                localVarQueryParameter['codeInsee'] = codeInsee;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Data Vote By Commune
         * @param {string} [codeInsee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteGet: async (codeInsee?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codeInsee !== undefined) {
                localVarQueryParameter['codeInsee'] = codeInsee;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Ilo Shape By Iris
         * @param {string} [codeInsee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteShapeGet: async (codeInsee?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vote/shape`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codeInsee !== undefined) {
                localVarQueryParameter['codeInsee'] = codeInsee;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Test
         * @param {string} [codeInsee] 
         * @param {string} [hash] 
         * @param {string} [lat] 
         * @param {string} [listOfIris] 
         * @param {string} [lon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteTestGet: async (codeInsee?: string, hash?: string, lat?: string, listOfIris?: string, lon?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vote/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codeInsee !== undefined) {
                localVarQueryParameter['codeInsee'] = codeInsee;
            }

            if (hash !== undefined) {
                localVarQueryParameter['hash'] = hash;
            }

            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }

            if (listOfIris !== undefined) {
                localVarQueryParameter['listOfIris'] = listOfIris;
            }

            if (lon !== undefined) {
                localVarQueryParameter['lon'] = lon;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BVCtrlApi - functional programming interface
 * @export
 */
export const BVCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BVCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Data
         * @param {string} [codeInsee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voteAllGet(codeInsee?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BvData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voteAllGet(codeInsee, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BVCtrlApi.voteAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Data Vote By Commune
         * @param {string} [codeInsee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voteGet(codeInsee?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BvData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voteGet(codeInsee, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BVCtrlApi.voteGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Ilo Shape By Iris
         * @param {string} [codeInsee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voteShapeGet(codeInsee?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: IrisShape; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voteShapeGet(codeInsee, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BVCtrlApi.voteShapeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Test
         * @param {string} [codeInsee] 
         * @param {string} [hash] 
         * @param {string} [lat] 
         * @param {string} [listOfIris] 
         * @param {string} [lon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voteTestGet(codeInsee?: string, hash?: string, lat?: string, listOfIris?: string, lon?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voteTestGet(codeInsee, hash, lat, listOfIris, lon, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BVCtrlApi.voteTestGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BVCtrlApi - factory interface
 * @export
 */
export const BVCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BVCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Data
         * @param {string} [codeInsee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteAllGet(codeInsee?: string, options?: RawAxiosRequestConfig): AxiosPromise<BvData> {
            return localVarFp.voteAllGet(codeInsee, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Data Vote By Commune
         * @param {string} [codeInsee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteGet(codeInsee?: string, options?: RawAxiosRequestConfig): AxiosPromise<BvData> {
            return localVarFp.voteGet(codeInsee, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Ilo Shape By Iris
         * @param {string} [codeInsee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteShapeGet(codeInsee?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: IrisShape; }> {
            return localVarFp.voteShapeGet(codeInsee, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Test
         * @param {string} [codeInsee] 
         * @param {string} [hash] 
         * @param {string} [lat] 
         * @param {string} [listOfIris] 
         * @param {string} [lon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteTestGet(codeInsee?: string, hash?: string, lat?: string, listOfIris?: string, lon?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.voteTestGet(codeInsee, hash, lat, listOfIris, lon, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BVCtrlApi - object-oriented interface
 * @export
 * @class BVCtrlApi
 * @extends {BaseAPI}
 */
export class BVCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Get Data
     * @param {string} [codeInsee] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BVCtrlApi
     */
    public voteAllGet(codeInsee?: string, options?: RawAxiosRequestConfig) {
        return BVCtrlApiFp(this.configuration).voteAllGet(codeInsee, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Data Vote By Commune
     * @param {string} [codeInsee] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BVCtrlApi
     */
    public voteGet(codeInsee?: string, options?: RawAxiosRequestConfig) {
        return BVCtrlApiFp(this.configuration).voteGet(codeInsee, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Ilo Shape By Iris
     * @param {string} [codeInsee] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BVCtrlApi
     */
    public voteShapeGet(codeInsee?: string, options?: RawAxiosRequestConfig) {
        return BVCtrlApiFp(this.configuration).voteShapeGet(codeInsee, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Test
     * @param {string} [codeInsee] 
     * @param {string} [hash] 
     * @param {string} [lat] 
     * @param {string} [listOfIris] 
     * @param {string} [lon] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BVCtrlApi
     */
    public voteTestGet(codeInsee?: string, hash?: string, lat?: string, listOfIris?: string, lon?: string, options?: RawAxiosRequestConfig) {
        return BVCtrlApiFp(this.configuration).voteTestGet(codeInsee, hash, lat, listOfIris, lon, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MapCtrlApi - axios parameter creator
 * @export
 */
export const MapCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Image
         * @param {string} [codeInsee] 
         * @param {string} [hash] 
         * @param {string} [lat] 
         * @param {string} [listOfIris] 
         * @param {string} [lon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapGenerateGet: async (codeInsee?: string, hash?: string, lat?: string, listOfIris?: string, lon?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/map/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codeInsee !== undefined) {
                localVarQueryParameter['codeInsee'] = codeInsee;
            }

            if (hash !== undefined) {
                localVarQueryParameter['hash'] = hash;
            }

            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }

            if (listOfIris !== undefined) {
                localVarQueryParameter['listOfIris'] = listOfIris;
            }

            if (lon !== undefined) {
                localVarQueryParameter['lon'] = lon;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Image
         * @param {string} [hash] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapGetGet: async (hash?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/map/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hash !== undefined) {
                localVarQueryParameter['hash'] = hash;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MapCtrlApi - functional programming interface
 * @export
 */
export const MapCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MapCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Image
         * @param {string} [codeInsee] 
         * @param {string} [hash] 
         * @param {string} [lat] 
         * @param {string} [listOfIris] 
         * @param {string} [lon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mapGenerateGet(codeInsee?: string, hash?: string, lat?: string, listOfIris?: string, lon?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mapGenerateGet(codeInsee, hash, lat, listOfIris, lon, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MapCtrlApi.mapGenerateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Image
         * @param {string} [hash] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mapGetGet(hash?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mapGetGet(hash, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MapCtrlApi.mapGetGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MapCtrlApi - factory interface
 * @export
 */
export const MapCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MapCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Image
         * @param {string} [codeInsee] 
         * @param {string} [hash] 
         * @param {string} [lat] 
         * @param {string} [listOfIris] 
         * @param {string} [lon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapGenerateGet(codeInsee?: string, hash?: string, lat?: string, listOfIris?: string, lon?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.mapGenerateGet(codeInsee, hash, lat, listOfIris, lon, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Image
         * @param {string} [hash] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapGetGet(hash?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.mapGetGet(hash, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MapCtrlApi - object-oriented interface
 * @export
 * @class MapCtrlApi
 * @extends {BaseAPI}
 */
export class MapCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Get Image
     * @param {string} [codeInsee] 
     * @param {string} [hash] 
     * @param {string} [lat] 
     * @param {string} [listOfIris] 
     * @param {string} [lon] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapCtrlApi
     */
    public mapGenerateGet(codeInsee?: string, hash?: string, lat?: string, listOfIris?: string, lon?: string, options?: RawAxiosRequestConfig) {
        return MapCtrlApiFp(this.configuration).mapGenerateGet(codeInsee, hash, lat, listOfIris, lon, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Image
     * @param {string} [hash] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapCtrlApi
     */
    public mapGetGet(hash?: string, options?: RawAxiosRequestConfig) {
        return MapCtrlApiFp(this.configuration).mapGetGet(hash, options).then((request) => request(this.axios, this.basePath));
    }
}



